import { render, staticRenderFns } from "./contest-rank.vue?vue&type=template&id=515bd0d4&scoped=true"
import script from "./contest-rank.vue?vue&type=script&lang=js"
export * from "./contest-rank.vue?vue&type=script&lang=js"
import style0 from "./contest-rank.vue?vue&type=style&index=0&id=515bd0d4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515bd0d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('515bd0d4')) {
      api.createRecord('515bd0d4', component.options)
    } else {
      api.reload('515bd0d4', component.options)
    }
    module.hot.accept("./contest-rank.vue?vue&type=template&id=515bd0d4&scoped=true", function () {
      api.rerender('515bd0d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/senate/contest-rank.vue"
export default component.exports